import { useRef, useState } from "react";
import {
    FormContainer,
    FormTopSection,
    FormInputsContainer,
    FormButtonsContainer,
    AddressInputRow,
    QRButtonContainer
} from "./ManageAddress.styles";
import TextInput from "@components/TextInput/TextInput";
import PrimaryButton from "@components/PrimaryButton/PrimaryButton";
import SectionLabel from "@components/SectionLabel/SectionLabel";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import QRButton from "@components/QRButton/QRButton";

export const AddressForm = ({
    onSave,
    onRemove,
    initialName,
    initialAddress,
    uuid,
    errorText,
    mode,
}: {
    onSave: (params: any) => void
    onRemove: (uuid: string) => void
    initialName?: string
    initialAddress?: string
    uuid?: string
    errorText?: string
    mode: 'add' | 'edit'
}) => {
    const { t } = useTranslation();

    const navigate = useNavigate()
    const location = useLocation();
    const scannedAddress = location?.state?.address || undefined

    const [name, setName] = useState(initialName || '')
    const [address, setAddress] = useState(initialAddress || scannedAddress || '')
    const nameInputRef = useRef<HTMLInputElement>(null);
    const addressInputRef = useRef<HTMLInputElement>(null);

    const handleSave = () => {
        onSave({
            uuid: uuid,
            name,
            address
        })
    }

    const handleRemove = () => {
        onRemove(uuid!)
    }

    return (
        <FormContainer>
            <FormTopSection>
                <SectionLabel>{t('bankAndAddress.address.form.sectionLabel')}</SectionLabel>
                <FormInputsContainer>
                    <AddressInputRow>
                        <TextInput
                            title={t('bankAndAddress.address.form.recipientAddress')}
                            placeholder={t('bankAndAddress.address.form.recipientAddressPlaceholder')}
                            value={address}
                            onChange={e => setAddress(e.target.value)}
                            ref={addressInputRef}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    addressInputRef.current?.blur();
                                }
                            }}
                            errorText={errorText}
                            isError={!!errorText}
                        />
                        <QRButtonContainer>
                            <QRButton onClick={() => {
                                const route = `/manage-address?mode=${mode}`;
                                navigate('/qr-scanner', { state: { from: route, to: route } });
                            }} />
                        </QRButtonContainer>
                    </AddressInputRow>
                    <TextInput
                        title={t('bankAndAddress.address.form.recipientName')}
                        placeholder={t('bankAndAddress.address.form.recipientNamePlaceholder')}
                        value={name}
                        onChange={e => setName(e.target.value)}
                        ref={nameInputRef}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === 'Tab') {
                                e.preventDefault();
                                addressInputRef.current?.focus();
                            }
                        }}
                    />
                </FormInputsContainer>
            </FormTopSection>
            <FormButtonsContainer>
                {mode === 'edit' && <PrimaryButton onClick={handleRemove} variant="danger">{t('bankAndAddress.address.form.removeButton')}</PrimaryButton>}
                <PrimaryButton
                    onClick={handleSave}
                    disabled={
                        !name ||
                        !address
                    }
                >
                    {t('bankAndAddress.address.form.saveButton')}
                </PrimaryButton>
            </FormButtonsContainer>
        </FormContainer>
    )
}